'use strict';

var _validationMixin = require('./components/validationMixin');

var _validationMixin2 = _interopRequireDefault(_validationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _validationMixin2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-validation-mixin/lib/index.js
// module id = 813
// module chunks = 0